import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'alco-party-vs-internet';

  constructor(public translateService: TranslateService, private router: Router, private metaTagService: Meta) {
    if (window.location.href === 'https://alco-party-vs-net.web.app/') {
      window.location.replace('https://drinking-party-vs-net.web.app/');
    }
    if (localStorage.getItem('language')) {
      this.translateService.setDefaultLang(localStorage.getItem('language'));
      this.translateService.use(localStorage.getItem('language'));
    } else {
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      [
        { name: 'description', content: this.translateService.instant('MetaDescription') },
        { name: 'keywords', content: this.translateService.instant('MetaKeywords') },
      ]
        .forEach(tag => this.metaTagService.updateTag(tag));
    });
  }
}
